import {
  Box,
  Container,
  Flex,
  Grid,
  Heading,
  Image,
  Select,
  Text,
} from "@chakra-ui/react";
import PortfolioBG from "../img/portfolio-map.png";
import Portfolio_1 from "../img/portfolio-1.png";
import Portfolio_2 from "../img/portfolio-2.png";
import Portfolio_3 from "../img/portfolio-3.png";
import React, { useEffect, useState } from "react";
import ButtonTheme from "../components/ButtonTheme";
import {API_BASE_IMAGES} from "../OldApp";
import {absoluteUrl, propertyUrl} from "../components/Utils";
import {Helmet} from "react-helmet";

export const usaStates = [
  { name: "Alabama", code: "AL" },
  { name: "Alaska", code: "AK" },
  { name: "Arizona", code: "AZ" },
  { name: "Arkansas", code: "AR" },
  { name: "California", code: "CA" },
  { name: "Colorado", code: "CO" },
  { name: "Connecticut", code: "CT" },
  { name: "Delaware", code: "DE" },
  { name: "Florida", code: "FL" },
  { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" },
  { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" },
  { name: "Indiana", code: "IN" },
  { name: "Iowa", code: "IA" },
  { name: "Kansas", code: "KS" },
  { name: "Kentucky", code: "KY" },
  { name: "Louisiana", code: "LA" },
  { name: "Maine", code: "ME" },
  { name: "Maryland", code: "MD" },
  { name: "Massachusetts", code: "MA" },
  { name: "Michigan", code: "MI" },
  { name: "Minnesota", code: "MN" },
  { name: "Mississippi", code: "MS" },
  { name: "Missouri", code: "MO" },
  { name: "Montana", code: "MT" },
  { name: "Nebraska", code: "NE" },
  { name: "Nevada", code: "NV" },
  { name: "New Hampshire", code: "NH" },
  { name: "New Jersey", code: "NJ" },
  { name: "New Mexico", code: "NM" },
  { name: "New York", code: "NY" },
  { name: "North Carolina", code: "NC" },
  { name: "North Dakota", code: "ND" },
  { name: "Ohio", code: "OH" },
  { name: "Oklahoma", code: "OK" },
  { name: "Oregon", code: "OR" },
  { name: "Pennsylvania", code: "PA" },
  { name: "Rhode Island", code: "RI" },
  { name: "South Carolina", code: "SC" },
  { name: "South Dakota", code: "SD" },
  { name: "Tennessee", code: "TN" },
  { name: "Texas", code: "TX" },
  { name: "Utah", code: "UT" },
  { name: "Vermont", code: "VT" },
  { name: "Virginia", code: "VA" },
  { name: "Washington", code: "WA" },
  { name: "West Virginia", code: "WV" },
  { name: "Wisconsin", code: "WI" },
  { name: "Wyoming", code: "WY" },
];

const featuredProperty = [
  "3300-old-milton-parkway",
  "436-n-bedford-dr",
  "1918-randolph-road",
  "4370-medical-arts-drive",
  "1950-sunny-crest-drive",
  "20207-chasewood-park-drive",
  "5655-hudson-drive",
  "4180-la-jolla-village-drive",
  "575-south-70th-street",
  "1545-east-southlake-blvd",
  "2021-k-street-nw",
  "239-hurffville-cross-keys-rd",
];

const Portfolio = () => {
  const [relatedProperty, setRelatedProperty] = useState([]);

  const handleButtonClick = () => {
    window.location.href = "/search?address=USA";
  };

  useEffect(() => {
    if (featuredProperty) {
      // Create an array of fetch promises
      const fetchPromises = featuredProperty.map((pro) =>
        fetch("/properties/" + pro + ".json", { mode: "cors" }).then(
          (response) => response.json()
        )
      );

      // When all fetch requests are complete
      Promise.all(fetchPromises)
        .then((data) => {
          console.log("relatedProperty..data", data);
          setRelatedProperty(data);

          // setRelatedProperty(prevProperties => [...prevProperties, ...data]);
          console.log("relatedProperty..", relatedProperty);
        })
        .catch((error) => console.error(error));
    }
  }, [relatedProperty]);

  return (
    <>
        <Helmet>
          <title>Welltower Medical Office For Lease - Our Portfolio</title>
          <link rel="canonical" href={ absoluteUrl( "/portfolio")} />
        </Helmet>
      <Box
        bgGradient="radial-gradient(36.09% 69.11% at 100% 33.15%, rgba(112, 207, 236, 0.48) 0%, rgba(116, 214, 241, 0) 100%)"
        pt={"78px"}
        bgImage={PortfolioBG}
        bgSize={{ md: "cover", base: "130% 60%" }}
        backgroundPosition={"top center"}
        backgroundRepeat={"no-repeat"}
      >
        <Container maxW={{ lg: "40%", md: "60%" }}>
          <Box textAlign={"center"} mt={12}>
            <Heading
              mb={12}
              fontSize={{ xl: "5xl", base: "4xl" }}
              color={"DarkTeal"}
            >
              Our Extensive Portfolio Across all 50 States
            </Heading>
          </Box>
        </Container>
        <Container
          maxW={{ md: "80%", sm: "90%", base: "100%" }}
          py={{ xl: 48, lg: 28, base: 8 }}
        >
          <Flex
            justifyContent={"space-around"}
            flexDir={{ md: "row", base: "column" }}
            alignItems={"center"}
          >
            <Flex
              p={{ lg: 6, md: 4 }}
              flexDir={"column"}
              justifyContent={"center"}
              textAlign={"center"}
              w={{ xl: "278px", lg: "250px", base: "200px" }}
              h={{ xl: "278px", lg: "250px", base: "200px" }}
              bgColor={"rgb(112 208 236 / 30%)"}
              borderRadius={"full"}
            >
              <Heading
                fontStyle={"italic"}
                fontWeight={"600"}
                fontSize={{ lg: "7xl", base: "5xl" }}
                color={"Teal"}
              >
                1970
              </Heading>
              <Text
                fontSize={{ lg: "md", md: "sm", base: "md" }}
                color={"DarkTeal"}
              >
                YEAR WELLTOWER FOUNDED
              </Text>
            </Flex>
            <Flex
              pos={{ base: "relative", md: "unset" }}
              top={-8}
              p={{ lg: 6, md: 4 }}
              flexDir={"column"}
              justifyContent={"center"}
              textAlign={"center"}
              w={{ xl: "278px", lg: "250px", base: "200px" }}
              h={{ xl: "278px", lg: "250px", base: "200px" }}
              bgColor={"rgb(41 100 145 / 30%)"}
              borderRadius={"full"}
            >
              <Heading
                fontStyle={"italic"}
                fontWeight={"600"}
                fontSize={{ lg: "7xl", base: "5xl" }}
                color={"DarkTeal"}
              >
                +430
              </Heading>
              <Text
                fontSize={{ lg: "md", md: "sm", base: "md" }}
                color={"DarkTeal"}
              >
                OUTPATIENT MEDICAL PROPERTIES
              </Text>
            </Flex>
            <Flex
              pos={{ base: "relative", md: "unset" }}
              top={-16}
              p={{ lg: 6, md: 4 }}
              flexDir={"column"}
              justifyContent={"center"}
              textAlign={"center"}
              w={{ xl: "278px", lg: "250px", base: "200px" }}
              h={{ xl: "278px", lg: "250px", base: "200px" }}
              bgColor={"rgb(38 85 90 / 30%)"}
              borderRadius={"full"}
            >
              <Heading
                fontStyle={"italic"}
                fontWeight={"600"}
                fontSize={{ lg: "7xl", base: "5xl" }}
                color={"Green"}
              >
                ~26
              </Heading>
              <Text
                fontSize={{ lg: "md", md: "sm", base: "md" }}
                color={"Green"}
              >
                MILLION SQ FT
              </Text>
            </Flex>
          </Flex>
        </Container>
        <Container maxW={{ xl: "35%", lg: "40%", md: "60%" }}>
          <Box textAlign={"center"} pt={{ md: 28, base: 0 }}>
            <Text pb={{ lg: 36, base: 18 }} color={"DarkBlue"}>
              Operating across various scales, systems, and 50 states, our
              endeavors stand as proof of our extensive and comprehensive
              expertise. These qualities offer our partners significant
              possibilities. Our medical leasing solutions are deliberately
              crafted to accommodate all circumstances. Explore notable
              selections from our portfolio below and witness firsthand.
            </Text>
          </Box>
        </Container>
      </Box>
      <Container
        pt={{ md: "91px", base: 16 }}
        maxW={{ md: "80%", sm: "90%", base: "100%" }}
      >
        <Flex justifyContent={{ md: "start", base: "center" }}>
          <ButtonTheme
            chakraProps={{
              mb: 12,
            }}
            btnText={"View all Properties"}
            handleButtonClick={handleButtonClick}
          />
        </Flex>
        <Grid
          gridTemplateColumns={{
            lg: "repeat(3,1fr)",
            sm: "repeat(2,1fr)",
            base: "repeat(1,1fr)",
          }}
          gap={12}
        >
          {relatedProperty.map((property, index) => (
            <Box>
              <a href={propertyUrl(property)}>
                <Image
                  borderTopLeftRadius={"150px"}
                  h={"300px"}
                  w={"300px"}
                  objectFit={"cover"}
                  src={API_BASE_IMAGES + property?.photos?.[0]?.path_300}
                />
                <Text mt={4} color={"DarkTeal"}>
                  {property?.name || ""}
                </Text>
                <Text color={"DarkBlue"}>
                  {" "}
                  {property?.city?.name || ""} {property?.state || ""}{" "}
                </Text>
              </a>
            </Box>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default Portfolio;
